import React from "react";

const OnboardInterest = ({
  width = 88,
  height = 88,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        fill="url(#paint0_linear_1050_34998)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        stroke="url(#paint1_linear_1050_34998)"
      />
      <g filter="url(#filter0_d_1050_34998)">
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect
          x="16.5"
          y="16.5"
          width="55"
          height="55"
          rx="27.5"
          stroke="#E2E4E9"
        />
        <path
          d="M46.3688 54.2312L44 56.6L41.6312 54.2312C36.9755 53.156 33.5 48.9812 33.5 44C33.5 38.204 38.204 33.5 44 33.5C49.796 33.5 54.5 38.204 54.5 44C54.5 48.9812 51.0245 53.156 46.3688 54.2312ZM37.7241 47.5868C39.2655 49.8863 41.5797 51.35 44.168 51.35C46.7552 51.35 49.0704 49.8874 50.6108 47.5868C48.8633 45.9536 46.5598 45.0466 44.168 45.05C41.7758 45.0464 39.4719 45.9534 37.7241 47.5868ZM44 42.95C44.8354 42.95 45.6366 42.6181 46.2274 42.0274C46.8181 41.4366 47.15 40.6354 47.15 39.8C47.15 38.9646 46.8181 38.1634 46.2274 37.5726C45.6366 36.9819 44.8354 36.65 44 36.65C43.1646 36.65 42.3634 36.9819 41.7726 37.5726C41.1819 38.1634 40.85 38.9646 40.85 39.8C40.85 40.6354 41.1819 41.4366 41.7726 42.0274C42.3634 42.6181 43.1646 42.95 44 42.95Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1050_34998"
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1050_34998"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1050_34998"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1050_34998"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1050_34998"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OnboardInterest;
